import { useQueryState, parseAsString } from "nuqs";
import { useProfile } from "./useProfile";
import { useMemo } from "react";

/**
 *
 * Custom hook to retrieve the referral code from the query state.
 */
const useReferralCode = () => {
  const [referralCode, setReferralCode] = useQueryState(
    "referralCode",
    parseAsString.withOptions({ clearOnDefault: true }).withDefault("")
  );

  const { data: userProfile, isLoading } = useProfile();

  const isOwnReferralCode = useMemo(() => {
    if (!referralCode) return false;
    if (!userProfile) return false;
    return userProfile.referral_code === referralCode;
  }, [userProfile, referralCode]);

  const result = useMemo(() => {
    return {
      isOwnReferralCode,
      referralCode,
      isReady: !isLoading,
      setReferralCode,
    };
  }, [isLoading, isOwnReferralCode, referralCode, setReferralCode]);

  return result;
};

export default useReferralCode;
